import * as cheerio from 'cheerio';

// 辅助函数，解析内容结构
export const parseContent = (data?: string) => {
  if (!data) {
    return [];
  }
  const doms = cheerio.load(data || '');
  const elements: any = doms('body').children();

  const result: any[] = [];
  const stack: any[] = []; // 用于维护层级关系的栈

  for (let i = 0; i < elements.length; i++) {
    const element = elements[i];
    let level = -1;
    let item: any = null;

    switch (element.tagName) {
      // case 'h1':
      //   level = 0
      //   item = {
      //     id: doms(element).attr('id'),
      //     name: doms(element).text(),
      //     children: [],
      //     level: 0,
      //   }
      //   break
      case 'h2':
        level = 1;
        item = {
          id: doms(element).attr('id'),
          name: doms(element).text(),
          children: [],
          level: 1,
        };
        break;
      case 'h3':
        level = 2;
        item = {
          id: doms(element).attr('id'),
          name: doms(element).text(),
          children: [],
          level: 2,
        };
        break;
      default:
        continue;
    }

    if (item) {
      // 清理栈，保留当前级别之上的父级
      while (stack.length > 0 && stack[stack.length - 1].level >= level) {
        stack.pop();
      }

      // 如果栈为空，说明这是顶级标题
      if (stack.length === 0) {
        result.push(item);
      } else {
        // 否则添加到最近的父级的 children 中
        stack[stack.length - 1].children.push(item);
      }

      // 将当前项添加到栈中
      stack.push(item);
    }
  }

  return result;
};

export const getFallbackText = (docDetail: any) => {
  return cheerio
    .load(docDetail || '')
    .text()
    .slice(0, 160);
};
